import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Comment from '../comment/Comment';
import Button from '../button/Button';
import { downloadComments } from '../../actions/comment-action';
import './style.css';


class ReviewLanding extends Component {
  componentDidMount() {
    this.props.downloadComments();
    window.scroll(0, 0);
  }

  onButtonMoreClick = (e) => {
    document.getElementsByClassName('js-more-reviews')[0].setAttribute('style', 'display: block;');
    e.target.setAttribute('style', 'display: none;');
  }

  render() {
    let comments;
    let unknownComments;
    let twitter;
    let button;
    let commentsListSort = [];
    this.props.eventCommentList.map(comment => {
      const commentKey = comment.idStr;
      commentsListSort[commentKey] = comment;
    });
    console.log(this.props.eventCommentList.length);
    if (this.props.isRand && this.props.eventCommentList.length > 2) {
      let firstComment = Number.parseInt(Math.random() * (this.props.eventCommentList.length));
      let secondComment = Number.parseInt(Math.random() * (this.props.eventCommentList.length));
      while (this.props.eventCommentList[firstComment].commentAuthorView.companyName === 'none') {
        firstComment = Number.parseInt(Math.random() * (this.props.eventCommentList.length));
      }
      while (firstComment === secondComment || this.props.eventCommentList[secondComment].commentAuthorView.companyName === 'none') {
        secondComment = Number.parseInt(Math.random() * (this.props.eventCommentList.length));
      }
      comments = [<Comment key={this.props.eventCommentList[firstComment].idStr} commentData={this.props.eventCommentList[firstComment]} styleClasses={[' ', ' ', ' ']} />,
        <Comment key={this.props.eventCommentList[secondComment].idStr} commentData={this.props.eventCommentList[secondComment]} styleClasses={[' ', ' ', ' ']} />];
    } else {
      comments = this.props.eventCommentList.map((commentKey) => {
        if (commentKey.commentAuthorView.companyName !== 'none') {
          return <Comment key={commentKey.idStr} commentData={commentKey} styleClasses={['review-column', 'review__text-min', ' ']} />
        }
      })
      button = <Button styleClasses={['review-button__more']} onClick={this.onButtonMoreClick.bind(this)}>еще&rarr;</Button>;
      unknownComments = this.props.eventCommentList.map((commentKey) => {
        if (commentKey.commentAuthorView.companyName === 'none') {
          return <Comment key={commentKey.idStr} commentData={commentKey} styleClasses={['review-column', 'review__text-min', 'review_none']} quotesElement={['«', '»']}/>
        }
      })
      // twitter = <Tweets />
    }
    return (
      <div>
        <section className='reviews clearfix'>
          <header className='reviews__title'>
            ЧТО ГОВОРЯТ?
          </header>
          <ul className='reviews__list clearfix'>
            {comments}
            {button}
            <div className='review_none js-more-reviews'>
              {unknownComments}
            </div>
          </ul>
        </section>
        {/*{twitter}*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    eventCommentList: state.comment.eventCommentList,
  }
};

const mapDispatchToProps = (dispatch) => ({
  downloadComments: bindActionCreators(downloadComments, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewLanding);



// WEBPACK FOOTER //
// ./src/blocks/review/ReviewLanding.js